module.exports = __webpack_public_path__ + "img/html.9dfe13e1.svg";